<embed [src]="url" *ngIf="showPdf" type="application/pdf" width="100%" height="100%" (error)="onError()">
